import { css } from 'lit';

export const style = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}

	.controls {
		display: flex;
		flex-direction: row;
		flex: 0;
		border-bottom: 1px solid var(--og-border-color);
	}

	/* toolbars shrink with the editor and scroll their items instead of overflowing */
	.controls > og-toolbar {
		flex: 0 1 auto;
		min-width: 0;
	}

	.body {
		flex: 1;
		overflow: hidden;
	}

	og-grid {
		height: 100%;
	}
`;
